import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import MobileSuccess from '../../../assets/images/mobile-success.svg';
import { actionTracking } from '../../../store/common/actions';
import { getQuickCashDraft } from '../storage';
import { QUICK_CASH_ROUTES } from '../routes';

function OTPSuccess() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // 새로고침으로 location.state가 사라지면 Quick Cash draft에서 인증 번호를 복원한다.
  const phone = location.state?.phone || getQuickCashDraft()?.meta?.phone;

  useEffect(() => {
    dispatch(actionTracking({ url: window.location.href, product_code: 'quick-cash-20000' }));
    if (!phone) navigate('/', { replace: true });
  }, [dispatch, navigate, phone]);

  return (
    <div className="bg-white p-5">
      <p className="flex-1 text-2xl text-primary2 text-right font-semibold border-b border-gray2 mb-4 pb-4">安全驗證</p>
      <div className="flex justify-center mb-5"><img src={MobileSuccess} alt="" /></div>
      <p className="text-2xl text-gray text-center">手機驗證成功</p>
      <div className="flex justify-center mt-9 mb-4">
        <button onClick={() => navigate(QUICK_CASH_ROUTES.consent, { replace: true, state: { phone } })} className="rounded-full text-white text-xl bg-primary px-12 py-3">下一步</button>
      </div>
    </div>
  );
}

export default OTPSuccess;
